"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enums = void 0;
var ManagedBy;
(function (ManagedBy) {
    ManagedBy["REPROGRAMA"] = "REPROGRAMA";
    ManagedBy["GREENHOUSE"] = "GREENHOUSE";
    ManagedBy["GUPY"] = "GUPY";
    ManagedBy["EXTERNAL_VACANCY"] = "EXTERNAL_VACANCY";
})(ManagedBy || (ManagedBy = {}));
var TypeOfCandidature;
(function (TypeOfCandidature) {
    TypeOfCandidature["OPEN"] = "OPEN";
    TypeOfCandidature["CLOSE"] = "CLOSE";
})(TypeOfCandidature || (TypeOfCandidature = {}));
var Type;
(function (Type) {
    Type["Presencial"] = "Presencial";
    Type["H\u00EDbrida"] = "H\u00EDbrida";
    Type["Remota"] = "Remota";
})(Type || (Type = {}));
var Status;
(function (Status) {
    Status["PENDING"] = "PENDING";
    Status["ACTIVE"] = "ACTIVE";
    Status["INACTIVE"] = "INACTIVE";
    Status["FINISHED"] = "FINISHED";
    Status["STOPPED"] = "STOPPED";
    Status["DISABLED"] = "DISABLED";
})(Status || (Status = {}));
exports.enums = {
    status: Status,
    typeOfCandidature: TypeOfCandidature,
    managedBy: ManagedBy,
    type: Type,
};
//# sourceMappingURL=PlacementVacancy.js.map